// extracted by mini-css-extract-plugin
module.exports = {"container":"TaskMessageModal-module__container--21QsJ","actions":"TaskMessageModal-module__actions--1G021"};